<loren-page-content>
  <mat-card-title>{{ "sidenav.traces" | transloco }}</mat-card-title>
  <div class="map-container">
    <div
      leaflet
      #mapWrapper
      [style.width]="'100%'"
      [style.height]="(mapHeight$ | async) + 'px'"
      [leafletOptions]="options"
      [leafletMarkerCluster]="markerClusterData"
      [leafletMarkerClusterOptions]="markerClusterOptions"
      (leafletMapMoveEnd)="handleMapMove()"
      (leafletMarkerClusterReady)="markerClusterReady($event)"
      (leafletMapReady)="onMapReady($event)"></div>

    @if(isTracesPlayerShown) {
    <div class="player-wrapper">
    @if (!playing) {
    <mat-icon class="player-btn hover-pointer" color="accent" (click)="play()">
      play_arrow
    </mat-icon>
    } @else {
    <mat-icon class="player-btn hover-pointer" color="accent" (click)="pause()">
      pause
    </mat-icon>
    }
    <div class="player-progress">
      <mat-slider
        #slider
        class="slider"
        color="accent"
        min="0"
        step="1"
        [max]="sliderMax"
        (input)="sliderSliding($event)"
        (mouseup)="sliderReleased()">
        <input matSliderThumb [value]="sliderValue" />
      </mat-slider>
    </div>
    <div class="settings-button-wrapper">
      <mat-icon
        color="accent"
        class="settings-btn hover-pointer"
        [matMenuTriggerFor]="settingsMenu"
        >more_horiz</mat-icon
      >
    </div>
    <mat-menu class="player-settings" #settingsMenu="matMenu" yPosition="above">
      <button
        mat-menu-item
        translate
        style="font-size: 14px"
        [matMenuTriggerFor]="playBackSpeedMenu"
        [matTooltip]="'tooltips.select_playback_speed' | transloco">
        {{ "traces_player.playback_speed" | transloco }}
      </button>
    </mat-menu>
    <mat-menu class="player-settings" #playBackSpeedMenu="matMenu">
      @for (option of playbackOptions; track option) {
      <button
        mat-menu-item
        style="font-size: 14px"
        [ngClass]="{
          'active accent': playbackSpeedSelectedValue === option.value
        }"
        (click)="changePlaybackSpeed(option.value)">
        <span>{{
          option.label ? (option.label | transloco) : option.value
        }}</span>
      </button>
      }
    </mat-menu>
    <div class="player-timestamp" [ngClass]="{ accent: slidingTimestamp }">
      {{ currentTraceTimestamp }}
    </div>
    </div>
    }
  </div>

  <div
    class="add-asset-trace-btn"
    [ngClass]="{ '-above': isHandset && isTracesPlayerShown }">
    <loren-location-filter
      [isHandset]="isHandset"
      [buttonBottomOffset]="locationFilterBtnBottomOffset"
      [lastSelectedDistance]="lastSelectedDistance"
      [disabled]="
        isAssetsDialogShown ||
        isPeriodDialogShown ||
        isColorSelectionDialogShown
      "
      (distanceSelected)="handleLocationDistanceSelection($event)"
      (exportTraceStopsDistanceReport)="
        handleExportTraceStopsDistanceSelectionReport()
      ">
    </loren-location-filter>
    <!--commented out because not currently in use
          and will need rework when used again -->
    <!-- <loren-layer-selection
        *lorenFeatureToggle="lorenFeatures.GENERIC_MAP_LAYERS_VISUALIZATION"
        [allMapLayers]="allMapLayers"
        [lastSelectedLayers]="lastSelectedLayers"
        [btnLook]="''"
        (finishLayerSelection)="handleLayerSelection($event)"
      >
      </loren-layer-selection> -->
    <br />
    <button
      mat-fab
      class="mat-elevation-z10"
      color="primary"
      [matTooltip]="'tooltips.select_assets' | transloco"
      (click)="showAssetListDialog()">
      <mat-icon>format_list_bulleted</mat-icon>
    </button>
  </div>

  @if(selectedAssetsForTracing.length > 0 && lastSelectedDistance === null) {
  <mat-chip-grid
    class="mat-chip-list-stacked asset-trace-chip-list"
    aria-orientation="vertical">
    @for(asset of selectedAssetsForTracing; track asset) {
    <mat-chip-option
      class="mat-elevation-z10"
      [selectable]="false"
      [style.background]="
        assetTraceMap.has(asset.id)
          ? assetTraceMap.get(asset.id).options.color
          : null
      "
      (click)="showAssetListDialog()">
      <span class="chip-txt">{{ asset.name }}</span>
    </mat-chip-option>
    }
  </mat-chip-grid>
  }
</loren-page-content>